import React from "react";
import { useTheme } from "styled-components";

export const Eye = () => {
  const theme = useTheme();

  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.0013 7.91602C3.22466 7.91602 1.87772 5.86412 1.40831 4.99937C1.8777 4.13461 3.22464 2.08268 6.0013 2.08268C8.77798 2.08268 10.1249 4.13464 10.5943 4.99938C10.1249 5.86409 8.77796 7.91602 6.0013 7.91602ZM6.0013 0.916016C2.14014 0.916016 0.535104 4.1272 0.233601 4.73041L0.229546 4.73853C0.147438 4.90275 0.147443 5.09605 0.22956 5.26028L0.233662 5.26848C0.535269 5.87183 2.14035 9.08268 6.0013 9.08268C9.86241 9.08268 11.4675 5.87159 11.769 5.26839L11.773 5.26026C11.8551 5.09605 11.8551 4.90276 11.773 4.73855L11.769 4.7305C11.4676 4.12743 9.8626 0.916016 6.0013 0.916016ZM6.0013 6.74935C6.9678 6.74935 7.7513 5.96585 7.7513 4.99935C7.7513 4.03285 6.9678 3.24935 6.0013 3.24935C5.0348 3.24935 4.2513 4.03285 4.2513 4.99935C4.2513 5.96585 5.0348 6.74935 6.0013 6.74935Z"
        fill={theme.colors.primary}
      />
    </svg>
  );
};
